import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Css/PlanCheck.css";
import "./Css/PlanCheck-responsive.css";
import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import NoDataCreated from "../../../../../Components/NoDataCreated";
import ErrorPage from "../../../../../Components/ErrorPage";
import PageLoader from "../../../../../Components/PageLoader";
import { goToTop } from "../../../../../Components/goToTop";
import { checkIsBuildingInspector, checkIsArchitect } from "../../../../../Utils/LoginUserRoleName";
import { PlanCheckTemplateList } from "../../../../../Controllers/Types/PlanCheck/PlanCheckType";
import { useAppDispatch, useAppSelector } from "../../../../../Controllers/hooks";
import { fetchPlanCheckReference, getAllPlanChckList } from "../../../../../Controllers/Thunks/PlanCheckThunks";
import { createPlanCheck } from "../../../../../Api/PlanCheck/PlanCheckApiServices";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { PlanCheck as PlanCheckType } from "../../../../../Controllers/Types/PlanCheck/PlanCheckType";
import { Tooltip } from "primereact/tooltip";
import CustomTableLoader from "../../../../../Components/CustomTableLoader";
import { PlanCheckDetailReference } from "../../../../../Controllers/Types/PlanCheck/PlanCheckReference";
import { AnimatePresence, motion } from "framer-motion";

const PlanCheck: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const toast = useRef<Toast>(null);
  const location = useLocation();
  const projectData = location.state?.data;
  const serviceId = Number(projectData.folder_id);

  // const [loadingPage, setLoadingPage] = useState<boolean>(false);
  const loadingPage = useAppSelector((state) => state?.planCheckList?.loader);
  const error = useAppSelector((state) => state?.planCheckList?.errorDisplay);

  const [showPlanCheckOptionsModal, setShowPlanCheckOptionsModal] = useState<boolean>(false);
  const [basicLoading, setBasicLoading] = useState<boolean>(false);
  const [detailLoading, setDetailLoading] = useState<boolean>(false);

  const [showCustomOptionModal, setShowCustomOptionModal] = useState<boolean>(false);

  const [showTemplatesModal, setShowTemplatesModal] = useState<boolean>(false);
  const [planCheckTemplatesData, setPlanCheckTemplatesData] = useState<PlanCheckTemplateList[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<PlanCheckTemplateList | null>(null);

  const [selectedCustomState, setSelectedCustomState] = useState<"Basic" | "Detail" | null>(null);



  /* Check role */
  const [isInspector, setIsInspector] = useState<boolean>(false);
  const [isArchitect, setIsArchitect] = useState<boolean>(false);

  useEffect(() => {
    const checkRole = async () => {
      const [inspectorResult, architectResult] = await Promise.all([
        checkIsBuildingInspector(),
        checkIsArchitect(),
      ]);

      setIsInspector(inspectorResult);
      setIsArchitect(architectResult);
    };

    checkRole();
  }, []);
  /*  */


  /* PERMISION HANDLER */
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const havePermissionAddPlanCheck = useCanEdit("Plan Check", "add_plan_check");
  const havePermissionEditPlanCheck = useCanEdit("Plan Check", "edit_plan_check");
  const havePermissionDeletePlanCheck = useCanEdit("Plan Check", "delete_plan_check");
  const havePermissionAddSignature = useCanEdit("Plan Check", "add_signature");
  const havePermissionDownloadFile = useCanEdit("Plan Check", "download_file");
  /*  */

  useEffect(() => {
    const loadData = async () => {
      const data = await dispatch(getAllPlanChckList(serviceId));
      const payload = data.payload as PlanCheckType[];

      if (payload && payload.length > 0) {
        navigate('list', { state: { data: projectData } });
      }
    };

    loadData();
  }, [dispatch, navigate, projectData, serviceId]);

  useEffect(() => {
    const fetchData = async () => {
      setPlanCheckTemplatesData([]);
      // setPlanCheckTemplatesData(planCheckTemplateLists)
    };
    fetchData();
  }, []);

  /* ****************************** Plan check ****************************** */
  /* Plan check */
  const handleCreatePlanCheck = () => {
    setShowPlanCheckOptionsModal(true);
  };

  const handleClosePlanCheckModal = () => {
    setShowPlanCheckOptionsModal(false);
  };

  const planCheckOptionModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Select plan check option</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleClosePlanCheckModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );
  /*  */

  /* For template */
  const handleShowTemplatesModal = () => {
    setShowTemplatesModal(true);
    setShowPlanCheckOptionsModal(false);
  };

  const handleCloseTemplatesModal = () => {
    setShowTemplatesModal(false);
    setShowPlanCheckOptionsModal(true);
  };

  const templatesModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Plan check templates</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseTemplatesModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const handleSelectPlanCheckTemplate = (template: PlanCheckTemplateList) => {
    setSelectedTemplate(template);
  };
  /*  */

  /* For custom */
  const handleShowCustomOption = () => {
    setShowCustomOptionModal(true);
    setShowPlanCheckOptionsModal(false);
  };

  const handleCloseCustomOptionModal = () => {
    setShowCustomOptionModal(false);
    setShowPlanCheckOptionsModal(true);
  };

  const customOptionModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Select custom option type</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseCustomOptionModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const handleCreateCustomPlanCheck = (mode: "Basic" | "Detail") => {
    confirmDialog({
      message: `Are you sure you want to create plan check with ${mode} mode?`,
      header: "Confirmation",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      accept: () => createCustomPlanCheck(mode),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
    setSelectedCustomState(mode);
  };

  //   database insert functions executed.
  const createCustomPlanCheck = async (mode: string) => {
    // selectedCustomState
    if (mode === 'Basic') {
      setBasicLoading(true);
    } else {
      setDetailLoading(true);
    }

    const data = await createPlanCheck(serviceId, mode);

    if (data.statusCode === 200) {
      // call dispach event
      dispatch(getAllPlanChckList(serviceId));

      if (mode === 'Basic') {
        setBasicLoading(false);
      } else {
        setDetailLoading(false);
      }
      handleCloseCustomOptionModal();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Plan check created successfully.",
          life: 3000,
        });
      }

      navigate(`list`, { state: { data: projectData } });
      goToTop();
    } else {
      if (mode === 'Basic') {
        setBasicLoading(false);
      } else {
        setDetailLoading(false);
      }

      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "An error occurred while creating the plan check.",
          life: 3000,
        });
      }
    }
  };
  /*  */
  /* *************************************************************************** */

  /* Plan check samples */
  const [showPlanCheckSampleModal, setShowPlanCheckSampleModal] = useState<boolean>(false);
  const [samplePlanCheckViewState, setSamplePlanCheckViewState] = useState<'Basic' | 'Detail'>('Basic');
  const [activePlanCheckDetail, setActivePlanCheckDetail] = useState<PlanCheckDetailReference | null>(null);

  const {
    loadingPlanCheckReference,
    planCheckReferences
  } = useAppSelector((state) => state?.planCheckList);

  useEffect(() => {
    dispatch(fetchPlanCheckReference());
  }, [dispatch]);

  const handleViewPlanCheckSample = (mode: 'Basic' | 'Detail') => {
    setSamplePlanCheckViewState(mode);
    setShowPlanCheckSampleModal(true);
    setShowCustomOptionModal(false);
  };

  const handleClosePlanCheckSampleModal = () => {
    setShowPlanCheckSampleModal(false);
    setShowCustomOptionModal(true);
  };

  const planCheckSampleModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{samplePlanCheckViewState} Plan check</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleClosePlanCheckSampleModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const handleToggleDetail = (part: PlanCheckDetailReference) => {
    setActivePlanCheckDetail((prevSelected) =>
      prevSelected?.id === part.id ? null : part
    );
  };
  /*  */


  /* **************************** Common functions ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              <ul className="page_breadcrumb">
                {isArchitect && (
                  <li className="page_breadcrumb_item has_child has_link"
                    onClick={() => navigate('/project')}
                  >
                    Shared folders
                  </li>
                )}

                <li
                  className={`page_breadcrumb_item has_child ${isInspector ? 'has_link' : ''}`}
                  onClick={() => isInspector ? navigate('/project/detail', { state: { projectData: projectData } }) : null}
                >
                  {projectData.job_number} : {projectData.address}
                </li>

                <li className="page_breadcrumb_item has_child">
                  {projectData.folder}
                </li>

                <li className="page_breadcrumb_item active">
                  {projectData.feature_name}
                </li>
              </ul>

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_main_content_section p-0">
              {isInspector ? (
                <div className="no_data_created_area with_pointing">
                  <img src="/assets/images/no_data/no_data_img.png" alt="No Data Found!" />
                  <h6>
                    No plan check has been created.
                    {havePermissionAddPlanCheck ? 'To create, click the Create button.' : ''}
                  </h6>

                  {havePermissionAddPlanCheck && (
                    <button className="add_data_link_btn fill radius p-ripple" onClick={handleCreatePlanCheck}>
                      <i className="bi bi-plus-circle"></i>
                      <span>Create plan check</span>
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </button>
                  )}
                </div>
              ) : (
                <div className="no_data_created_area with_pointing">
                  <img src="/assets/images/no_data/no_data_img.png" alt="No Data Found!" />
                  <h6>
                    No plan check was issued by the building inspector!
                  </h6>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Plan check option modal */}
      <Dialog
        visible={showPlanCheckOptionsModal}
        header={planCheckOptionModalHeader}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_xsm"
        onHide={handleClosePlanCheckModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="custom_option_btn_area">
            <Tooltip target=".info_icon" position="top" />

            <button
              className="custom_pc_option_btn p-ripple"
              onClick={handleShowTemplatesModal}
              disabled={planCheckTemplatesData?.length === 0}
            >
              <span>
                <i className="bi bi-ui-checks-grid me-2"></i>
                Template
              </span>

              {planCheckTemplatesData?.length === 0 && (
                <i className="bi bi-question-circle info_icon"
                  data-pr-tooltip="No templates are available now. It will be available soon."
                ></i>
              )}

              <i className="bi bi-chevron-right"></i>
              <Ripple />
            </button>

            <button
              className="custom_pc_option_btn p-ripple"
              onClick={handleShowCustomOption}
            >
              <span>
                <i className="bi bi bi-pencil-square me-2"></i>
                Custom
              </span>
              <i className="bi bi-chevron-right"></i>
              <Ripple />
            </button>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Custom option modal */}
      <Dialog
        visible={showCustomOptionModal}
        header={customOptionModalHeader}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseCustomOptionModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="custom_option_area">
            <div className="row">
              <div className="col-12 col-sm-6 divide">
                <div className="custom_option_container">
                  <h6 className="custom_option_head">
                    <i className="bi bi-card-checklist me-2"></i>
                    Basic
                  </h6>

                  <p className="custom_option_desc">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Deserunt atque hic
                  </p>

                  <div className="custom_option_btn_container">
                    <Button
                      label="View sample"
                      icon="bi bi-eye"
                      iconPos="left"
                      onClick={() => handleViewPlanCheckSample("Basic")}
                      className="custom_btn sm primary outlined"
                    />

                    <Button
                      label={`${basicLoading ? "Processing" : "Create"}`}
                      icon="bi bi-chevron-right"
                      iconPos="right"
                      onClick={() => handleCreateCustomPlanCheck("Basic")}
                      loading={basicLoading}
                      className="custom_btn sm primary outlined"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="custom_option_container">
                  <h6 className="custom_option_head">
                    <i className="bi bi-card-list me-2"></i>
                    Detail
                  </h6>

                  <p className="custom_option_desc">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Deserunt atque hic excepturi laboriosam qui natus iure modi
                    aperiam in similique?
                  </p>

                  <div className="custom_option_btn_container">
                    <Button
                      label="View sample"
                      icon="bi bi-eye"
                      iconPos="left"
                      onClick={() => handleViewPlanCheckSample("Detail")}
                      className="custom_btn sm primary outlined"
                    />

                    <Button
                      label={`${detailLoading ? "Processing" : "Create"}`}
                      icon="bi bi-chevron-right"
                      iconPos="right"
                      onClick={() => handleCreateCustomPlanCheck("Detail")}
                      loading={detailLoading}
                      className="custom_btn sm primary outlined"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Template options modal */}
      <Dialog
        visible={showTemplatesModal}
        header={templatesModalHeader}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_lg"
        onHide={handleCloseTemplatesModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="plan_check_templates_area">
            {planCheckTemplatesData?.length > 0 ? (
              <React.Fragment>
                <h6 className="plan_check_template_head">Choose a template:</h6>
                <div className="row sow_template_row">
                  {planCheckTemplatesData?.map((template) => (
                    <div
                      key={template.id}
                      className="col-12 col-sm-6 col-lg-6 col-xl-4"
                    >
                      <article
                        className="sow_template p-ripple"
                        style={{ backgroundColor: template.color_code }}
                        onClick={() => handleSelectPlanCheckTemplate(template)}
                      >
                        <div className="temp_icon">
                          <img src={template.logo} alt={template.name} />
                        </div>
                        <h6>{template.name}</h6>
                        <Ripple />
                      </article>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <NoDataCreated
                containerClassname="pos_rel"
                message={`There are no templates for plan check. Try creating one using the custom option.`}
              />
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Plan check sample modal */}
      <Dialog
        visible={showPlanCheckSampleModal}
        header={planCheckSampleModalHeader}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleClosePlanCheckSampleModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="page_main_content_section mt-0">
            {loadingPlanCheckReference ? (
              <CustomTableLoader />
            ) : (
              planCheckReferences && (
                samplePlanCheckViewState === 'Basic' ? (
                  planCheckReferences?.basic_part?.length > 0 ? (
                    <div className="pck_track_list_area">
                      <div className="table-responsive pck_track_list_table_area">
                        <table className="table pck_track_list_table">
                          <thead>
                            <tr>
                              <th style={{ width: "100%" }}>Item detail</th>
                            </tr>
                          </thead>

                          <tbody>
                            {planCheckReferences?.basic_part.map((item) => (
                              <tr key={item?.id} className="part_item_row">
                                <td style={{ width: "100%" }}>
                                  <div className="item_list_wrapper">
                                    <div className="pck_track_list_item_area warning">
                                      <div className="pck_track_list_item_header">
                                        <span className="item_code">
                                          {item?.item_code ?? '---'}.
                                        </span>

                                        <span className="item_cmt">
                                          {item?.comment ?? '---'}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <NoDataCreated
                      containerClassname="w-100"
                      message="No basic plan check reference data available."
                    />
                  )
                ) : (
                  planCheckReferences?.detail_part?.length > 0 ? (
                    <div className="pck_track_list_area">
                      <div className="table-responsive pck_track_list_table_area">
                        <table className="table pck_track_list_table">
                          <thead>
                            <tr>
                              <th style={{ width: "4%" }} className="text_no_wrap"></th>

                              <th style={{ width: "16%" }} className="text_no_wrap">
                                Part no.
                              </th>

                              <th style={{ width: "70%" }} className="text_no_wrap">
                                Part title
                              </th>

                              <th style={{ width: "10%" }} />
                            </tr>
                          </thead>

                          <tbody>
                            {planCheckReferences?.detail_part.map((part) => {
                              const isActive = part?.id === activePlanCheckDetail?.id;
                              return (
                                <React.Fragment>
                                  <tr
                                    key={`part_${part?.id}`}
                                    onClick={() => handleToggleDetail(part)}
                                    className={`part_row ${isActive ? "active" : ""}`}
                                  >
                                    <td
                                      style={{ width: "3rem" }}
                                      className="text-center">
                                      <i className={`bi bi-chevron-right ${isActive ? "toggled" : ""} data_toggle_icon`}></i>
                                    </td>

                                    <td
                                      style={{ width: "16%" }}
                                      className="text_no_wrap">
                                      {part?.part_number}
                                    </td>

                                    <td
                                      style={{ width: "70%" }}
                                      className="note_column"
                                    >
                                      {part?.part_title}
                                    </td>

                                    <td style={{ width: "10%" }}>
                                      <div className="item_count_lable warning h-auto py-3">
                                        <span>
                                          {String(part?.item_list?.length).padStart(2, '0')}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>

                                  <AnimatePresence initial={false}>
                                    {isActive && (
                                      <tr className="part_item_row">
                                        <td
                                          colSpan={4}
                                          style={{ width: "100%" }}
                                          className="p-0">
                                          <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3, ease: [0.3, 0, 0.2, 1], }}
                                            style={{ overflow: "hidden" }}>
                                            <div className="item_list_wrapper">
                                              {part?.item_list && part?.item_list?.length > 0 ? (
                                                <React.Fragment>
                                                  {part?.item_list.map((item) => (
                                                    <div key={`item_${item?.id}`}
                                                      className="pck_track_list_item_area warning">
                                                      <div className="pck_track_list_item_header ps-4">
                                                        <span className="item_code">
                                                          {item?.item_code}.
                                                        </span>

                                                        <span className="item_cmt first_letter_capitalized">
                                                          {item?.comment}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </React.Fragment>
                                              ) : (
                                                <div className="no_item_area">
                                                  <span>
                                                    {`No item available for ${part?.part_title}.`}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </motion.div>
                                        </td>
                                      </tr>
                                    )}
                                  </AnimatePresence>
                                </React.Fragment>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <NoDataCreated
                      containerClassname="w-100"
                      message="No detail plan check reference data available."
                    />
                  )
                )
              )
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

    </React.Fragment>
  );
};

export default PlanCheck;
